customElements.define(
  "info-cards",
  class InfoCards extends HTMLElement {
    constructor() {
      super();

      this.cards = this.querySelectorAll(".js-info-card");

      this.cards.forEach((card) => {
        card.addEventListener("click", () => {
          this.cards.forEach((cd) => {
            const rd = this.querySelector(`[data-block-id="${cd.dataset.id}"]`);
            if (cd.dataset.id != card.dataset.id) {
              console.log(rd);
              rd.classList.add("hide");
            }
          });
          const id = card.dataset.id;
          const related = this.querySelector(`[data-block-id="${id}"]`);
          console.log(related.classList.contains("hide"));
          console.log(related);
          if (related.classList.contains("hide")) {
            related.classList.remove("hide");
          } else {
            related.classList.add("hide");
          }
        });
      });

      document.addEventListener("click", (e) => {
        if (!e.target.closest(".js-info-card")) {
          this.querySelectorAll(".info-card__full-info__card").forEach(
            (slide) => slide.classList.add("hide")
          );
        }
      });
    }
  }
);

class WithSwiper extends HTMLElement {
  constructor() {
    super();
  }

  createSlider(listParent, options) {
    const swiper = document.createElement("div");
    const wrapper = document.createElement("div");
    const slide = document.createElement("div");

    swiper.classList.add("swiper");
    wrapper.classList.add("swiper-wrapper");
    slide.classList.add("swiper-slide");

    Array.from(listParent.children).forEach((child) => {
      const newSlide = slide.cloneNode(true);
      newSlide.appendChild(child);
      wrapper.appendChild(newSlide);
    });

    swiper.appendChild(wrapper);
    listParent.appendChild(swiper);

    const Swiper = window.Swiper;

    return new Swiper(swiper, options);
  }

  createNavigation(className, customSVG) {
    const leftBtn = document.createElement("div");
    const rightBtn = document.createElement("div");
    [leftBtn, rightBtn].forEach((btn) => {
      btn.classList.add(`${className}-btn`);
    });

    leftBtn.innerHTML = customSVG
      ? customSVG
      : `<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M11.3335 5.99984L0.666833 5.99984M0.666833 5.99984L5.69489 0.666505M0.666833 5.99984L5.69489 11.3332" stroke="#4A332E" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    rightBtn.innerHTML = customSVG
      ? customSVG
      : `<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M0.666503 6.00016L11.3332 6.00016M11.3332 6.00016L6.30511 11.3335M11.3332 6.00016L6.30511 0.666829" stroke="#4A332E" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    const navigation = document.createElement("div");
    navigation.classList.add(className);
    navigation.appendChild(leftBtn);
    navigation.appendChild(rightBtn);

    return [navigation, leftBtn, rightBtn];
  }

  createPagination(className) {
    const pagination = document.createElement("div");
    pagination.classList.add("swiper-pagination");
    if (className) pagination.classList.add(className);

    return pagination;
  }
}

class FeaturedIngredients extends WithSwiper {
  constructor() {
    super();

    this.mobileSlidesWrapper = this.querySelector(".js-mobile-slides");
    this.cards = this.querySelectorAll(".js-toggle-ingredient");
    if (!this.mobileSlidesWrapper?.children.length) return;

    this.cards.forEach((card) => {
      card.addEventListener("click", (e) => {
        this.cards.forEach((cd) => {
          const rd = this.querySelector(`[data-block-id="${cd.dataset.id}"]`);
          if (cd.dataset.id != card.dataset.id) {
            rd.classList.add("hide");
          }
        });
        const id = card.dataset.id;
        const related = this.querySelector(`[data-block-id="${id}"]`);
        related.classList.toggle("hide");
      });
    });

    document.addEventListener("click", (e) => {
      console.log("clicked", e.target.closest(".js-toggle-ingredient"));
      if (!e.target.closest(".js-toggle-ingredient")) {
        this.querySelectorAll(".featured-ingredients__slide").forEach((slide) =>
          slide.classList.add("hide")
        );
      }
    });

    this.mobileSlidesWrapper.classList.remove("--swiper-no-init");

    const pagination = this.createPagination();

    this.swiperInstance = this.createSlider(this.mobileSlidesWrapper, {
      slidesPerView: "auto",
      pagination: {
        el: pagination,
      },
    });

    this.mobileSlidesWrapper.appendChild(pagination);

    window.innerWidth < 990 &&
      Array.from(this.querySelectorAll(".js-mob-slide [data-bid]")).forEach(
        (item) => {
          item.addEventListener("click", () => {
            if (window.innerWidth > 990) {
              return;
            }
            console.log(window.innerWidth);
            const id = item.getAttribute("data-bid");
            if (id) {
              const target = this.querySelector(
                `.js-ingredient[data-bid="${id}"]`
              );
              console.log(target);
              if (target) target.click();
            }
          });
        }
      );
  }
}

customElements.define("featured-ingredients", FeaturedIngredients);

class DynamicGallery extends HTMLElement {
  constructor() {
    super();

    this.images = Array.from(
      this.querySelectorAll(".js-dynamic-gallery-image")
    );
    if (this.images.length < 8) return;

    this.interval = Number(this.getAttribute("data-interval"));

    this.currentInterval = null;

    this.initGallery = this.initGallery.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.initGallery();

    window.addEventListener("resize", this.handleResize);
  }

  handleResize() {
    if (
      (window.innerWidth > 990 && this.currentInterval.tiles === 4) ||
      (window.innerWidth <= 990 && this.currentInterval.tiles === 3)
    ) {
      clearInterval(this.currentInterval.interval);
      this.currentInterval = null;
      this.images.forEach((image) => (image.style.display = "none"));
      this.initGallery();
    }
  }

  initGallery() {
    const numOfSets = window.innerWidth > 990 ? 3 : 4;
    const imagesPerSet = Math.floor(this.images.length / numOfSets);

    const sets = Array.from(Array(numOfSets).keys()).map((setIdx) => {
      if (setIdx + 1 === numOfSets) {
        return this.images.slice(setIdx * imagesPerSet);
      } else {
        return this.images.slice(
          setIdx * imagesPerSet,
          (setIdx + 1) * imagesPerSet
        );
      }
    });

    sets.forEach((set) => {
      set[0].style.display = "block";
    });

    let nextSet = 0;
    let activePerSet = sets.map(() => 0);

    this.currentInterval = {
      tiles: numOfSets,
      interval: setInterval(() => {
        let currentSet = nextSet;
        nextSet = nextSet === numOfSets - 1 ? 0 : nextSet + 1;

        const set = sets[currentSet];
        const size = set.length;
        const active = activePerSet[currentSet];
        const next = active === size - 1 ? 0 : active + 1;

        set[active].style.display = "none";
        set[next].style.display = "block";

        activePerSet[currentSet] = next;
      }, this.interval * 1000),
    };

    this.setAttribute("data-initialized", true);
  }
}

customElements.define("dynamic-gallery", DynamicGallery);

class CustomTestimonials extends WithSwiper {
  constructor() {
    super();

    this.imagesWrapper = this.querySelector(".js-testimonial-images");
    this.contentsWrapper = this.querySelector(".js-testimonial-contents");
    this.mobileSlidesWrapper = this.querySelector(".js-testimonials-mobile");

    if (!this.imagesWrapper?.children.length) return;

    this.imagesWrapper.classList.remove("--swiper-no-init");

    if (this.imagesWrapper.children.length < 6) {
      const times = Math.ceil(6 / this.imagesWrapper.children.length);
      const imageClones = [];
      const contentClones = [];
      Array.from(Array(times - 1).keys()).forEach((time) => {
        Array.from(this.imagesWrapper.children).forEach((item, idx) => {
          imageClones.push(item.cloneNode(true));
          console.log(this.contentsWrapper.children, idx);
          contentClones.push(
            this.contentsWrapper.children[idx].cloneNode(true)
          );
        });
      });
      this.imagesWrapper.append(...imageClones);
      this.contentsWrapper.append(...contentClones);
    }

    this.totalSlides = this.imagesWrapper.children.length;

    const [nav, prev, next] = this.createNavigation(
      "testimonial-images-swiper__nav"
    );

    this.imagesSwiperInstance = this.createSlider(this.imagesWrapper, {
      slidesPerView: 3,
      loop: true,
      spaceBetween: 32,
      allowTouchMove: false,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
    });

    this.contentsSwiperInstance = this.createSlider(this.contentsWrapper, {
      slidesPerView: 1,
      loop: true,
      effect: "fade",
      autoHeight: true,
      allowTouchMove: false,
    });

    this.imagesWrapper.appendChild(nav);
    this.lastClicked = 0;
    this.index = 0;

    prev.addEventListener("click", () => {
      if (this.lastClicked === 0) {
        this.lastClicked = -1;
        this.index = this.index === 0 ? this.totalSlides - 1 : this.index - 1;
      }
    });

    next.addEventListener("click", () => {
      if (this.lastClicked === 0) {
        this.lastClicked = 1;
        this.index = this.index === this.totalSlides - 1 ? 0 : this.index + 1;
      }
    });

    this.imagesSwiperInstance.on("slideChangeTransitionEnd", () => {
      if (this.lastClicked !== 0) {
        this.contentsSwiperInstance.slideTo(this.index);
        this.lastClicked = 0;
      }
    });

    const [mobileNav, mobilePrev, mobileNext] = this.createNavigation(
      "testimonial-images-swiper__nav"
    );

    this.mobileSwiperInstance = this.createSlider(this.mobileSlidesWrapper, {
      slidesPerView: 1,
      loop: true,
      autoHeight: true,
      navigation: {
        prevEl: mobilePrev,
        nextEl: mobileNext,
      },
      spaceBetween: 10,
    });

    this.mobileSlidesWrapper.append(mobileNav);
  }
}

customElements.define("custom-testimonials", CustomTestimonials);

class TestimonialsGrid extends WithSwiper {
  constructor() {
    super();

    this.testimonialsWrapper = this.querySelector(".js-testimonials-wrapper");

    this.initSlider = this.initSlider.bind(this);
    this.destroySlider = this.destroySlider.bind(this);

    window.addEventListener("resize", () => {
      if (window.innerWidth > 1110 && this.swiperInstance) {
        this.destroySlider();
      } else if (window.innerWidth <= 1110 && !this.swiperInstance) {
        this.initSlider();
      }
    });

    if (window.innerWidth <= 1110) this.initSlider();
  }

  initSlider() {
    if (!Swiper) return;

    this.pagination = this.createPagination();
    this.swiperInstance = this.createSlider(this.testimonialsWrapper, {
      slidesPerView: 1,
      autoHeight: true,
      spaceBetween: 13,
      pagination: {
        el: this.pagination,
      },
    });

    this.testimonialsWrapper.append(this.pagination);
  }

  destroySlider() {
    this.swiperInstance.destroy(true, true);
    this.swiperInstance = null;
    const originalItems = Array.from(
      this.testimonialsWrapper.querySelectorAll(".js-testimonial")
    );
    const swiperEl = this.testimonialsWrapper.querySelector(".swiper");
    this.testimonialsWrapper.removeChild(swiperEl);
    originalItems.forEach((item) => {
      this.testimonialsWrapper.appendChild(item);
    });
    this.pagination.parentElement.removeChild(this.pagination);
  }
}

customElements.define("testimonials-grid", TestimonialsGrid);

class TeamSlider extends WithSwiper {
  constructor() {
    super();

    this.teamSliderWrapper = this.querySelector(".js-team-slider-wrapper");

    const pagination = this.createPagination();
    const [nav, prev, next] = this.createNavigation("general-swiper__nav");

    this.swiperInstance = this.createSlider(this.teamSliderWrapper, {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: pagination,
      },
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      breakpoints: {
        678: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 60,
        },
      },
    });

    this.teamSliderWrapper.append(pagination);
    this.teamSliderWrapper.append(nav);
  }
}

customElements.define("team-slider", TeamSlider);

class FeaturedArticles extends WithSwiper {
  constructor() {
    super();

    this.articlesWrapper = this.querySelector(".js-featured-articles-wrapper");

    const pagination = this.createPagination();

    this.swiperInstance = this.createSlider(this.articlesWrapper, {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: pagination,
      },
      breakpoints: {
        990: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });

    this.articlesWrapper.append(pagination);
  }
}

customElements.define("featured-articles", FeaturedArticles);

class SlidingIcons extends WithSwiper {
  constructor() {
    super();

    this.iconsWrapper = this.querySelector(".js-info-icons");

    if (!this.iconsWrapper || !this.iconsWrapper?.children?.length) return;

    this.iconsWrapper.classList.remove("--swiper-no-init");

    const autoplay = this.iconsWrapper.getAttribute("data-autoplay");
    const delay = Number(this.iconsWrapper.getAttribute("data-delay"));

    const loop = !!this.iconsWrapper.getAttribute("data-loop");
    const hasPagination = !!this.iconsWrapper.getAttribute("data-pagination");
    const hasNavigation = !!this.iconsWrapper.getAttribute("data-navigation");
    const centeredSlides = !!this.iconsWrapper.getAttribute("data-center");
    const centerMobile = !!this.iconsWrapper.getAttribute("data-center-mobile");
    const hasSpaceBetween =
      this.iconsWrapper.getAttribute("data-space-between");

    const sb2num = Number(hasSpaceBetween);
    const spaceBetween = isNaN(sb2num) ? 0 : sb2num;

    const gc2num = Number(this.iconsWrapper.getAttribute("data-per-slide"));
    const slidesPerView = !isNaN(gc2num) && gc2num > 0 ? gc2num : "auto";

    const pagination = this.createPagination();
    const [nav, prev, next] = this.createNavigation("general-swiper__nav");

    if (loop && this.iconsWrapper.children.length < 30) {
      const times = Math.ceil(30 / this.iconsWrapper.children.length);
      const itemClones = [];
      Array.from(Array(times - 1).keys()).forEach(() => {
        Array.from(this.iconsWrapper.children).forEach((item) => {
          itemClones.push(item.cloneNode(true));
        });
      });
      this.iconsWrapper.append(...itemClones);
    }

    const config = {
      slidesPerView: "auto",
      loop: loop,
      centeredSlides: centeredSlides || centerMobile,
      speed: 350,
      autoplay: autoplay
        ? {
            delay: delay * 1000,
          }
        : false,
      spaceBetween: spaceBetween,
    };

    if (hasPagination)
      config.pagination = {
        el: pagination,
      };
    if (hasNavigation)
      config.navigation = {
        prevEl: prev,
        nextEl: next,
      };

    if (slidesPerView !== "auto") {
      config.breakpoints = {
        750: {
          slidesPerView: slidesPerView,
          slidesPerGroup: slidesPerView,
        },
      };
    }

    if (!centeredSlides && centerMobile) {
      if (config.breakpoints?.[750]) {
        config.breakpoints[750].centeredSlides = false;
      } else {
        config.breakpoints = {
          750: {
            centeredSlides: false,
          },
        };
      }
    }

    this.swiperInstance = this.createSlider(this.iconsWrapper, config);

    if (hasPagination) {
      this.iconsWrapper.append(pagination);
    }
    if (hasNavigation) {
      this.iconsWrapper.append(nav);
    }
  }
}

customElements.define("sliding-icons", SlidingIcons);

class SwiperModal extends HTMLElement {
  constructor() {
    super();
    this.slides = this.children;
    this.triggerClass = this.getAttribute("data-trigger-class");
    if (!this.slides.length || !this.triggerClass) return;

    this.section = this.closest(".shopify-section");

    this.videoPlayBtns = Array.from(
      this.querySelectorAll(".js-modal-video-play")
    );

    this.triggers = document.querySelectorAll("." + this.triggerClass);

    if (!this.triggers.length) return;

    this.width = this.getAttribute("data-width");
    this.maxWidth = this.getAttribute("data-max-width");
    this.destroyWhenSmall = this.getAttribute("data-destroy-small");

    this.container = document.createElement("div");
    this.container.classList.add("swiper-modal__container");

    this.containerInner = document.createElement("div");
    this.containerInner.classList.add("swiper-modal__container-inner");
    this.container.appendChild(this.containerInner);

    this.swiper = document.createElement("div");
    this.swiperWrapper = document.createElement("div");

    Array.from(this.slides).forEach((slide) => {
      const slideWrapper = document.createElement("div");
      slideWrapper.classList.add("swiper-slide");
      slideWrapper.appendChild(slide);
      this.swiperWrapper.appendChild(slideWrapper);
    });

    this.swiperWrapper.classList.add("swiper-wrapper");
    this.swiper.classList.add("swiper");
    this.swiper.setAttribute(
      "style",
      `width: ${this.width || "490px"}; max-width: ${
        this.maxWidth || "1300px"
      };`
    );
    this.swiper.appendChild(this.swiperWrapper);

    this.containerInner.appendChild(this.swiper);

    this.appendChild(this.container);

    this.leftBtn = document.createElement("div");
    this.rightBtn = document.createElement("div");
    this.closeBtn = document.createElement("div");
    this.backBtn = document.createElement("div");
    this.muteBtn = document.createElement("div");

    [this.leftBtn, this.rightBtn].forEach((btn) => {
      btn.classList.add("swiper-modal__nav-btn");
      btn.addEventListener("click", () => {
        this.muteActiveVideo();
        this.classList.remove("--video-mode");
      });
    });

    this.closeBtn.classList.add("swiper-modal__close-btn");
    this.backBtn.classList.add("swiper-modal__back-btn");
    this.muteBtn.classList.add("swiper-modal__mute-btn");
    this.muteBtn.setAttribute("data-muted", true);

    this.leftBtn.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M11.3335 5.99984L0.666833 5.99984M0.666833 5.99984L5.69489 0.666505M0.666833 5.99984L5.69489 11.3332" stroke="rgb(var(--color-fg))" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    this.rightBtn.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M0.666503 6.00016L11.3332 6.00016M11.3332 6.00016L6.30511 11.3335M11.3332 6.00016L6.30511 0.666829" stroke="rgb(var(--color-fg))" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    this.closeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M13 1L1 13" stroke="black"/><path d="M1 1L13 13" stroke="rgb(var(--color-fg))"/></svg>`;
    this.backBtn.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M11.3335 5.99984L0.666833 5.99984M0.666833 5.99984L5.69489 0.666505M0.666833 5.99984L5.69489 11.3332" stroke="rgb(var(--color-fg))" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    this.muteBtn.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 100 100" fill="none">
        <g><path fill="rgb(var(--color-fg))" d="M51,8.5v83L28.6,71.3L9,71.2V28.9l19.6-0.1L51,8.5z M77,8.5l1.3,2C86.7,23.6,91,36.8,91,50   c0,13-4.1,26-12.3,38.9l-0.4,0.7l-1.3,2l-4-2.5l1.3-2c8-12.4,12-24.8,12-37.1c0-12.1-3.8-24.2-11.6-36.4l-0.4-0.7L73,11L77,8.5z    M64,19.5l1.2,2C71.1,31,74,40.5,74,50c0,9.3-2.8,18.7-8.4,27.9l-0.4,0.6l-1.2,2l-4-2.4l1.2-2c5.4-8.8,8.1-17.5,8.1-26.1   c0-8.5-2.6-17-7.7-25.5l-0.4-0.6l-1.2-2L64,19.5z"/></g>
      </svg>
      <svg width="18" height="18" viewBox="0 0 100 100" fill="none">
        <g><path fill="rgb(var(--color-fg))" d="M52.6,8.5v83L30.2,71.3l-19.6-0.1V28.9l19.6-0.1L52.6,8.5z M85.5,35.4l3.5,3.5L78.8,49.1l10.6,10.6l-3.5,3.5   L75.3,52.7L65,62.9l-3.5-3.5l10.3-10.3l-9.9-9.9l3.5-3.5l9.9,9.9L85.5,35.4z"/></g>
      </svg>
    `;

    this.navigation = document.createElement("div");
    this.navigation.appendChild(this.leftBtn);
    this.navigation.appendChild(this.rightBtn);
    this.navigation.classList.add("swiper-modal__nav");

    this.containerInner.appendChild(this.navigation);
    this.swiper.appendChild(this.closeBtn);
    this.swiper.appendChild(this.backBtn);
    this.swiper.appendChild(this.muteBtn);

    this.swiperInstance = null;

    this.initSlider = this.initSlider.bind(this);
    this.destroySlider = this.destroySlider.bind(this);
    this.muteActiveVideo = this.muteActiveVideo.bind(this);

    Array.from(this.triggers).forEach((trigger, idx) => {
      trigger.addEventListener("click", () => this.initSlider(idx));
    });

    this.closeBtn.addEventListener("click", this.destroySlider);
    this.backBtn.addEventListener("click", () => {
      this.muteActiveVideo();
      this.classList.remove("--video-mode");
    });
    this.muteBtn.addEventListener("click", () => {
      const video = this.muteBtn
        .closest(".swiper")
        ?.querySelector(".swiper-slide-active video");
      if (this.muteBtn.getAttribute("data-muted") && video) {
        video.muted = false;
        this.muteBtn.removeAttribute("data-muted");
      } else if (video) {
        video.muted = true;
        this.muteBtn.setAttribute("data-muted", true);
      }
    });
    this.container.addEventListener("click", this.destroySlider);
    this.containerInner.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    this.videoPlayBtns.forEach((playBtn) => {
      playBtn.addEventListener("click", (e) => {
        this.classList.add("--video-mode");
        const video = playBtn.parentElement.querySelector("video");
        if (video) video.currentTime = 0;
      });
    });

    if (this.destroyWhenSmall) {
      window.addEventListener("resize", () => {
        if (window.innerWidth <= 990 && this.swiperInstance) {
          this.destroySlider();
        }
      });
    }
  }

  initSlider(idx) {
    if (!Swiper) return;
    const maxWidthInit = this.dataset.maxWidthInit;
    if (maxWidthInit && window.innerWidth > parseInt(maxWidthInit)) return;

    this.swiperInstance = new Swiper(this.swiper, {
      loop: true,
      navigation: {
        prevEl: this.leftBtn,
        nextEl: this.rightBtn,
      },
      initialSlide: idx,
      autoHeight: true,
      allowTouchMove: false,
    });
    this.classList.add("--active");
    document.documentElement.style.overflow = "hidden";
  }

  destroySlider() {
    this.muteActiveVideo();
    this.classList.remove("--video-mode");
    this.classList.remove("--active");
    this.swiperInstance.destroy(true, false);
    this.swiperInstance = null;
    document.documentElement.style.overflow = "unset";
  }

  muteActiveVideo() {
    const video = this.querySelector(".swiper-slide-active video");
    if (video) video.muted = true;
    this.muteBtn.setAttribute("data-muted", true);
  }
}

customElements.define("swiper-modal", SwiperModal);

class BenefitsDetailed extends WithSwiper {
  constructor() {
    super();

    this.benefitPages = Array.from(this.querySelectorAll(".js-benefit-page"));
    this.benefitCardsDesktop = Array.from(
      this.querySelectorAll(".js-benefit-cards-desktop .js-benefit-card")
    );
    this.benefitCardsMobile = Array.from(
      this.querySelectorAll(".js-benefit-cards-mobile .js-benefit-card")
    );

    let activeBenefitPage = this.benefitPages[0];
    let activeBenefitCardDesktop = this.benefitCardsDesktop[0];
    let activeBenefitCardMobile = this.benefitCardsMobile[0];

    const toggleActiveAttribute = (elements, remove) => {
      if (remove) {
        elements.forEach((element) => {
          element.removeAttribute("data-active");
        });
      } else {
        elements.forEach((element) => {
          element.setAttribute("data-active", true);
        });
      }
    };

    this.benefitCardsDesktop.forEach((card, idx) => {
      card.addEventListener("click", () => {
        if (card !== activeBenefitCardDesktop) {
          toggleActiveAttribute([
            card,
            this.benefitPages[idx],
            this.benefitCardsMobile[idx],
          ]);
          toggleActiveAttribute(
            [
              activeBenefitCardDesktop,
              activeBenefitCardMobile,
              activeBenefitPage,
            ],
            true
          );

          activeBenefitCardDesktop = card;
          activeBenefitCardMobile = this.benefitCardsMobile[idx];
          activeBenefitPage = this.benefitPages[idx];
        }
      });
    });

    this.benefitCardsMobile.forEach((card, idx) => {
      card.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (card !== activeBenefitCardMobile) {
          toggleActiveAttribute([
            card,
            this.benefitPages[idx],
            this.benefitCardsDesktop[idx],
          ]);
          toggleActiveAttribute(
            [
              activeBenefitCardDesktop,
              activeBenefitCardMobile,
              activeBenefitPage,
            ],
            true
          );

          activeBenefitCardMobile = card;
          activeBenefitCardDesktop = this.benefitCardsDesktop[idx];
          activeBenefitPage = this.benefitPages[idx];

          window.scrollBy({
            top: this.getBoundingClientRect().top - 100,
            behavior: "smooth",
          });
        }

        toggleActiveAttribute([card.parentElement], true);
        const introBody = this.benefitPages[idx].querySelector(
          ".js-accordion[data-active=true] .js-accordion-body"
        );
        introBody.style.height = `${introBody.scrollHeight}px`;
      });
    });

    this.benefitContentTriggersWrappers = Array.from(
      this.querySelectorAll(".js-benefit-content-triggers-wrapper")
    );

    this.benefitContentTriggersWrappers.forEach((wrapper) => {
      const benefitContentTriggers = Array.from(
        wrapper.querySelectorAll(".js-benefit-content-trigger")
      );
      const benefitContents = Array.from(
        wrapper.parentElement.querySelectorAll(".js-benefit-content")
      );

      let activeTrigger = benefitContentTriggers[0];
      let activeContent = benefitContents[0];

      benefitContentTriggers.forEach((trigger, idx) => {
        trigger.addEventListener("click", () => {
          if (trigger !== activeTrigger) {
            trigger.setAttribute("data-active", true);
            benefitContents[idx].setAttribute("data-active", true);

            activeTrigger.removeAttribute("data-active");
            activeContent.removeAttribute("data-active");

            activeTrigger = trigger;
            activeContent = benefitContents[idx];
          }
        });
      });
    });

    this.benefitCardsMobileWrapper = document.querySelector(
      ".js-benefit-cards-mobile .js-wrapper"
    );
    if (this.benefitCardsMobileWrapper) {
      this.benefitCardsMobileWrapper.addEventListener("click", () => {
        toggleActiveAttribute([this.benefitCardsMobileWrapper]);
      });
    }
  }
}

customElements.define("benefits-detailed", BenefitsDetailed);

class IngredientsShort extends WithSwiper {
  constructor() {
    super();

    this.mobileSlidesWrapper = this.querySelector(".js-mobile-slides");
    if (!this.mobileSlidesWrapper.children.length) return;

    const pagination = this.createPagination();

    this.swiperInstance = this.createSlider(this.mobileSlidesWrapper, {
      slidesPerView: "auto",
      pagination: {
        el: pagination,
      },
    });

    this.mobileSlidesWrapper.appendChild(pagination);
  }
}

customElements.define("ingredients-short", IngredientsShort);

class CustomMediaGallery extends WithSwiper {
  constructor() {
    super();

    this.mediaWrapper = this.querySelector(".js-cmg-main");
    this.thumbsWrapper = this.querySelector(".js-cmg-thumbs");

    this.mediaSlides = Array.from(this.mediaWrapper.children);
    this.thumbSlides = Array.from(this.thumbsWrapper.children);

    this.initSliders = this.initSliders.bind(this);
    this.switchGallery = this.switchGallery.bind(this);
    this.zoomImages = this.zoomImages.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.setMaxThumbs = this.setMaxThumbs.bind(this);

    this.desktop = true;
    this.maxThumbsHorizontal = 20;
    this.maxThumbsVertical = 20;

    this.sectionId = this.closest(".shopify-section").id;

    this.zoomImages();

    this.initSliders();
    this.handleResize();

    window.addEventListener("resize", this.handleResize);

    window.addEventListener("custom:buying-option", (e) => {
      this.switchGallery(e.detail.subs);
    });
  }

  initSliders() {
    if (
      !this.mediaWrapper?.children.length ||
      !this.thumbsWrapper?.children.length
    )
      return;

    this.thumbsLen = this.thumbsWrapper.children.length;
    let activeVideo = null;

    const [nav, prev, next] = this.createNavigation(
      "cmg-thumbs-nav",
      `<svg width="12" height="7" viewBox="0 0 12 7" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7524 0.20499C12.0547 0.465022 12.0843 0.915601 11.8186 1.21139L6.57545 6.75773C6.4415 6.90683 6.25008 6.99454 6.04727 6.99975C5.84445 7.00496 5.6486 6.9272 5.50683 6.78518L0.207432 1.21139C-0.0737995 0.929656 -0.0683849 0.478176 0.219525 0.20298C0.507436 -0.0722158 0.968816 -0.0669173 1.25005 0.214815L6 5.23818L10.7239 0.269729C10.9897 -0.0260568 11.4501 -0.0550414 11.7524 0.20499Z" fill="#4A332E"/>
      </svg>`
    );

    if (this.thumbsSwiperInstance) this.thumbsSwiperInstance.destroy();
    this.thumbsSwiperInstance = this.createSlider(this.thumbsWrapper, {
      direction: window.innerWidth < 990 ? "horizontal" : "vertical",
      loop: true,
      spaceBetween: 10,
      slidesPerView: "auto",
      freeMode: false,
      watchSlideProgress: true,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });

    this.thumbsWrapper.appendChild(nav);

    if (this.mediaSwiperInstance) this.mediaSwiperInstance.destroy();
    this.mediaSwiperInstance = this.createSlider(this.mediaWrapper, {
      loop: true,
      spaceBetween: 10,
      thumbs: {
        swiper: this.thumbsSwiperInstance,
      },
      effect: "fade",
    });

    this.mediaSwiperInstance.on("slideChange", () => {
      if (activeVideo) {
        activeVideo.pause();
        activeVideo.currentTime = 0;
        activeVideo = null;
      }
      const index = this.mediaSwiperInstance.activeIndex;
      const video = this.mediaWrapper
        .querySelectorAll(".swiper-slide")
        [index]?.querySelector("video");
      if (video) {
        activeVideo = video;
        video.play();
      }
      this.mediaSlides.forEach((slide) => {
        if (slide.getAttribute("data-type") === "image") {
          slide.classList.remove("--zoom");
        }
      });
    });

    this.setMaxThumbs(true);
  }

  switchGallery(subs) {
    const params = new URLSearchParams(window.location.search);
    if (subs) {
      params.delete("purchase"); // Not including it means "subscription"
    } else {
      params.set("purchase", "one-time");
    }

    fetch(
      `${window.location.pathname}?section_id=${
        this.sectionId
      }&${params.toString()}`
    )
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newGallery = doc.querySelector("custom-media-gallery");
        const oldGallery = document.querySelector("custom-media-gallery");
        oldGallery.replaceWith(newGallery);

        // Re-initialize Swiper and zoom
        this.mediaWrapper = newGallery.querySelector(".js-cmg-main");
        this.thumbsWrapper = newGallery.querySelector(".js-cmg-thumbs");
        this.mediaSlides = Array.from(this.mediaWrapper.children);
        this.thumbSlides = Array.from(this.thumbsWrapper.children);

        this.initSliders();
        this.zoomImages();
      });
  }

  zoomImages() {
    const imageContainers = this.mediaSlides.filter(
      (slide) => slide.getAttribute("data-type") === "image"
    );
    imageContainers.forEach((container) => {
      const image = container.querySelector("img");
      const ratio = image.height / image.width;
      const zoomBox = container.querySelector(".js-cmg-zoom-box");
      const src = zoomBox.getAttribute("data-img-src");
      let imageLoaded = false;

      container.addEventListener("mousemove", (e) => {
        if (window.innerWidth < 990) return;
        if (!imageLoaded) {
          zoomBox.classList.add("--loading");
          let dummyImg = new Image();
          dummyImg.addEventListener("load", () => {
            imageLoaded = true;
            zoomBox.style.backgroundImage = `url("${src}")`;
            zoomBox.classList.remove("--loading");
            dummyImg = null;
          });
          dummyImg.src = src;
        }
        const rect = container.getBoundingClientRect();
        const xPos = e.clientX - rect.left;
        const yPos = e.clientY - rect.top;
        const xPercent = `${xPos / (image.clientWidth / 100)}%`;
        const yPercent = `${yPos / ((image.clientWidth * ratio) / 100)}%`;

        zoomBox.style.backgroundPosition = `${xPercent} ${yPercent}`;
        zoomBox.style.backgroundSize = `${image.width * 1.75}px`;
      });

      container.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        container.classList.add("--zoom");
        if (!imageLoaded) {
          zoomBox.classList.add("--loading");
          let dummyImg = new Image();
          dummyImg.addEventListener("load", () => {
            imageLoaded = true;
            zoomBox.style.backgroundImage = `url("${src}")`;
            zoomBox.classList.remove("--loading");
            dummyImg = null;
          });
          dummyImg.src = src;
        }
      });

      container.addEventListener("touchstart", (e) => {
        if (e.touches.length === 2) {
          e.preventDefault();
          e.stopPropagation();
        }
      });

      zoomBox.addEventListener("pointermove", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      let allowPan = false;
      let allowZoom = false;
      let initRatio = 1;
      let finRatio = 1;
      let initDistance = 0;
      let finDist = 0;
      let initPos = {
        x: 0,
        y: 0,
      };
      let initBgPos = [50, 50];
      let finBgPos = [50, 50];

      zoomBox.addEventListener("touchstart", (e) => {
        const touches = e.touches;
        if (touches.length === 1) {
          allowPan = true;
          initPos = { x: touches[0].clientX, y: touches[0].clientY };
        } else if (touches.length === 2) {
          allowZoom = true;
          initDistance = Math.sqrt(
            (Math.abs(touches[0].clientX - touches[1].clientX) ^ 2) +
              (Math.abs(touches[0].clientY - touches[1].clientY) ^ 2)
          );
        }
      });

      zoomBox.addEventListener("touchmove", (e) => {
        const touches = e.touches;
        if (touches.length === 1 && allowPan) {
          e.preventDefault();
          e.stopPropagation();
          const touch = e.touches[0];

          const xDiff = touch.clientX - initPos.x;
          const yDiff = touch.clientY - initPos.y;

          const finBgX = Math.max(
            Math.min(initBgPos[0] - xDiff / initRatio / 2.5, 100),
            0
          );
          const finBgY = Math.max(
            Math.min(initBgPos[1] - yDiff / initRatio / 2.5, 100),
            0
          );

          finBgPos = [finBgX, finBgY];

          zoomBox.style.backgroundPosition = `${finBgX}% ${finBgY}%`;
        } else if (touches.length === 2 && allowZoom) {
          let distance = Math.sqrt(
            (Math.abs(touches[0].clientX - touches[1].clientX) ^ 2) +
              (Math.abs(touches[0].clientY - touches[1].clientY) ^ 2)
          );
          if (distance === finDist) return;
          finDist = distance;

          finRatio = Math.max((distance * initRatio) / initDistance, 1);
          zoomBox.style.backgroundSize = `${image.width * finRatio}px`;
        }
      });

      zoomBox.addEventListener("touchend", () => {
        allowZoom = false;
        allowPan = false;
        initBgPos = finBgPos;
        initRatio = finRatio;
      });

      zoomBox
        .querySelector(".js-cmg-zoom-close")
        ?.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          container.classList.remove("--zoom");
        });
    });
  }

  handleResize() {
    const iw = window.innerWidth;

    // Toggle Desktop state;
    if (iw >= 990 && !this.desktop) {
      this.desktop = true;
      this.thumbsSwiperInstance.changeDirection("vertical", true);
    }
    if (iw < 990 && this.desktop) {
      this.desktop = false;
      this.thumbsSwiperInstance.changeDirection("horizontal", true);
    }

    this.setMaxThumbs();
  }

  setMaxThumbs(force) {
    const iw = window.innerWidth;
    if (force) {
      this.maxThumbsHorizontal = 20;
      this.maxThumbsVertical = 20;
    }
    const setVertical = (num) => {
      this.maxThumbsVertical = num;
      this.maxThumbsHorizontal = 10;
      this.thumbsWrapper.style.width = "unset";
      this.thumbsWrapper.style.height = `${
        Math.min(this.thumbsLen, num) * 95 - 10
      }px`;
    };

    const setHorizontal = (num, small) => {
      this.maxThumbsHorizontal = num;
      this.maxThumbsVertical = 10;
      this.thumbsWrapper.style.height = "unset";
      this.thumbsWrapper.style.width = `${
        Math.min(this.thumbsLen, num) * (small ? 60 : 95) - 10
      }px`;
    };

    if (iw >= 1150 && this.maxThumbsVertical !== 5) {
      setVertical(5);
    } else if (iw >= 1050 && iw < 1150 && this.maxThumbsVertical !== 4) {
      setVertical(4);
    } else if (iw >= 990 && iw < 1050 && this.maxThumbsVertical !== 3) {
      setVertical(3);
    } else if (iw >= 678 && iw < 990 && this.maxThumbsHorizontal !== 5) {
      setHorizontal(5);
    } else if (iw >= 450 && iw < 678 && this.maxThumbsHorizontal !== 4) {
      setHorizontal(4, true);
    } else if (iw < 450 && this.maxThumbsHorizontal !== 3) {
      setHorizontal(3, true);
    }
  }
}

customElements.define("custom-media-gallery", CustomMediaGallery);

class TextBlocks extends WithSwiper {
  constructor() {
    super();

    this.textBlocksWrapper = this.querySelector(".js-text-blocks");

    this.initSlider = this.initSlider.bind(this);
    this.destroySlider = this.destroySlider.bind(this);

    window.addEventListener("resize", () => {
      if (window.innerWidth > 768 && this.swiperInstance) {
        this.destroySlider();
      } else if (window.innerWidth <= 768 && !this.swiperInstance) {
        this.initSlider();
      }
    });

    if (window.innerWidth <= 768) this.initSlider();
  }

  initSlider() {
    if (!Swiper) return;

    this.pagination = this.createPagination();
    this.swiperInstance = this.createSlider(this.textBlocksWrapper, {
      slidesPerView: "auto",
      spaceBetween: 22,
      pagination: {
        el: this.pagination,
      },
    });

    this.textBlocksWrapper.append(this.pagination);
  }

  destroySlider() {
    this.swiperInstance.destroy(true, true);
    this.swiperInstance = null;
    const originalItems = Array.from(
      this.textBlocksWrapper.querySelectorAll(".js-text-block")
    );
    const swiperEl = this.textBlocksWrapper.querySelector(".swiper");
    this.textBlocksWrapper.removeChild(swiperEl);
    originalItems.forEach((item) => {
      this.textBlocksWrapper.appendChild(item);
    });
    this.pagination.parentElement.removeChild(this.pagination);
  }
}

customElements.define("text-blocks", TextBlocks);
